// extracted by mini-css-extract-plugin
export default {"contact":"ContactDataFrom_contact__JxJJX","contact__toolbar":"ContactDataFrom_contact__toolbar__xpYet","contact--active":"ContactDataFrom_contact--active__gdAf7"};